import styled from 'react-emotion'

const Caption = styled('div')`
	display: block;
	font-weight: 600;
	text-align: center;
`

export default Caption
